import styled from 'styled-components';
import { Typography, Button } from '@experian-uk/corvetteuk-common-ui';

import Container from '../../Container';
import ValidatedField from '../../ValidatedField';
import IdentityFraud from './assets/identity-fraud.jpg';
import IdentityFraudXL from './assets/identity-fraud@2x.jpg';
import IdentityFraudXXL from './assets/identity-fraud@3x.jpg';

const { Copy, Headings } = Typography;

export const TakeCareContainer = styled(Container)`
  background: rgb(196,210,228);
  background: linear-gradient(180deg, rgba(196,210,228,1) 0%, rgba(232,237,244,1) 10%, rgba(232,237,244,1) 15%, rgba(234,239,245,1) 30%);
  border-radius: 0 0 4rem 4rem;
  margin: 0;
  max-width: 100%;
  padding: 0;
  position: relative;
  text-align: center;

  ${({ theme: { media } }) => media('15', `
    padding: 0;
  `)}

  ${({ theme }) => theme.media('20', `
    background-image: url(${IdentityFraud});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0;
    padding: 5rem 0;
    text-align: left;
  `)}

  ${({ theme }) => theme.media('30', `
    background-position: auto;
    max-width: 100%;
  `)}

  @media(min-width: 3600px) {
    background-image: url(${IdentityFraudXL});
  }

  @media(min-width: 5400px) {
    background-image: url(${IdentityFraudXXL});
  }
`;

export const Heading = styled(Headings.Primary)`
  color: ${({ theme }) => theme.colors.landingPageBlue};
  line-height: 1.3;
  margin-bottom: 1rem;

  span {
    font-weight: 500;
  }
`;

export const StyledCopy = styled(Copy.Text)`
  line-height: 1.56;
  margin: 0.5rem 0 0.9rem 0;
`;

export const StrongStyledCopy = styled(StyledCopy)`
  font-weight: 400;
  margin-bottom: 1.875rem;
`;

export const VoucherInput = styled(ValidatedField)`
  flex: 1 1 1;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  margin: 1.375rem 0;
  width: 90%;

  ${({ theme: { media } }) => media('20', `
    margin: 0;
    max-width: 320px !important;
    width: 320px !important;
  `)}
`;

export const SubmitButton = styled(Button)`
  margin: 1.875rem 0;
  width: 100%;
  height: 50px;

  span {
    margin-top: -3px;
  }

  ${({ theme: { media } }) => media('15', `
    flex: 0 1 30%;
    margin: 0;
    width: auto;
  `)}

  ${({ theme: { media } }) => media('20', `
    margin-left: 1.875rem;
    max-width: 198px;
  `)};
`;

export const FlexibleContainer = styled(Container)`
  padding-bottom: 0;

  ${({ theme: { media } }) => media('15', `
    padding-bottom: 2.5rem;
  `)}

  ${({ theme: { media } }) => media('20', `
    padding-bottom: 0;
  `)}

  ${({ theme: { media } }) => media('30', `
    padding: 0;
  `)}
`;

export const Content = styled.div`
  ${({ theme: { media } }) => media('20', `
    max-width: 67%;
    text-align: left;
  `)}

  ${({ theme: { media } }) => media('21', `
    max-width: 63%;
    text-align: left;
  `)}
`;

export const ActionsContainer = styled(Container)`
  padding-top: 0;
  position: relative;

  input {
    font-size: ${({ theme }) => theme.typography.baseFontSize};
      height: 50px;
    ${({ theme: { media } }) => media('15', `
      min-width: 320px;
    `)};

    &::placeholder {
      color: ${({ theme }) => theme.colors.baseDarkGrey};
      text-align: center;
    }
  }

  small {
    flex-basis: 100% !important;
  }

  ${({ theme: { media } }) => media('15', `
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    text-align: left;

    & > *:first-child {
      flex: 0 1 60%;
    }
  `)};

  ${({ theme: { media } }) => media('20', `
    justify-content: flex-start;
    margin-left: 0;
    max-width: 100%;

    & > *:first-child {
      flex: 0 1 auto;
    }
  `)};

  ${({ theme: { media } }) => media('30', `
    padding-bottom: 0.875rem;
  `)};
`;

export const SpinnerContainer = styled.div`
  margin: 1.5rem auto;

  ${({ theme: { media } }) => media('15', `
    align-items: center;
    display: flex;
    margin: 0.75rem 0 0 1.875rem;
  `)};
`;
